import {
  COMPLETED_PATH,
  CREDIT_NOTE_PATH,
  DASHBOARD_PATH,
  DOCUMENT_STATES,
  DOCUMENT_TYPE_CODES,
  DOCUMENT_VIEW_PATH,
  DOCUMENTS_RECEIVED_PATH,
  ENTERED_PATH,
  ON_HOLD_PATH,
  PENDING_PATH,
  REIMBURSEMENT_PATH,
  REJECTED_PATH,
  RETENTION_RECEIPT_PATH,
} from "lib"
import { DocumentsReceivedDashboard, DocumentView } from "pages"
import React from "react"
import { Route } from "react-router-dom"

const DocumentsReceived = () => {
  return (
    <React.Fragment>
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${DASHBOARD_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            forReception
            showCounts
            issuingCompany
            initialCode={DOCUMENT_TYPE_CODES.companyReception}
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${ENTERED_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialState={DOCUMENT_STATES.entered}
            initialCode={DOCUMENT_TYPE_CODES.companyReception}
            hideState
            issuingCompany
            forReception
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${PENDING_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialState={DOCUMENT_STATES.pending}
            initialCode={DOCUMENT_TYPE_CODES.companyReception}
            hideState
            forReception
            issuingCompany
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialState={DOCUMENT_STATES.finished}
            initialCode={DOCUMENT_TYPE_CODES.companyReception}
            hideState
            forReception
            issuingCompany
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${ON_HOLD_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialState={DOCUMENT_STATES.onHold}
            initialCode={DOCUMENT_TYPE_CODES.companyReception}
            hideState
            forReception
            issuingCompany
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${CREDIT_NOTE_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialCode={DOCUMENT_TYPE_CODES.creditNote}
            initialState={DOCUMENT_STATES.pending}
            issuingCompany
            hideType
            forReception
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />

      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${RETENTION_RECEIPT_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialCode={DOCUMENT_TYPE_CODES.retentionReceipt}
            receivingCompany
            hideType
            forEmission
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />

      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${DOCUMENT_VIEW_PATH}`}
        component={props => <DocumentView isDocumentReceived={true} {...props} />}
      />

      <Route
        strict
        path={`${DOCUMENTS_RECEIVED_PATH}${REIMBURSEMENT_PATH}`}
        component={() => (
          <DocumentsReceivedDashboard
            showOnHoldCount
            initialCode={DOCUMENT_TYPE_CODES.reimbursements}
            forReception
            receivingCompany
            hideType
            redirectOnApprove={`${DOCUMENTS_RECEIVED_PATH}${COMPLETED_PATH}`}
            redirectOnReject={`${DOCUMENTS_RECEIVED_PATH}${REJECTED_PATH}`}
          />
        )}
      />
    </React.Fragment>
  )
}

export default DocumentsReceived
